import { Application, type ControllerConstructor } from '@hotwired/stimulus'

const application = Application.start()

// Auto-register every *_controller.ts: theme_controller.ts -> "theme", users/list_controller.ts -> "users--list"
const modules = import.meta.glob<{ default: ControllerConstructor }>('./**/*_controller.ts', { eager: true })
for (const [path, module] of Object.entries(modules)) {
  const name = path.replace(/^\.\//, '').replace(/_controller\.ts$/, '').replace(/\//g, '--').replace(/_/g, '-')
  application.register(name, module.default)
}

export { application }
